// Compact en/pl language flip — small enough to live in the corner of
// auth screens (login, change-password) without competing with the
// page's primary content. The persistent SideNav has its own toggle
// for the post-login experience; this is purely for pre-login screens
// where the SideNav isn't rendered.

import { useTranslation } from "../i18n";
import ukFlag from "../images/uk.svg";
import plFlag from "../images/pl.svg";
import "../styles/language-toggle.css";

interface Props {
    className?: string;
}

const LanguageToggle = ({ className = "" }: Props) => {
    const { language, setLanguage } = useTranslation();
    const next = language === "en" ? "pl" : "en";
    const nextLabel = next === "pl" ? "Polski" : "English";
    return (
        <button
            type="button"
            className={`language-toggle ${className}`.trim()}
            onClick={() => setLanguage(next)}
            aria-label={nextLabel}
            title={nextLabel}
        >
            <img
                src={language === "en" ? ukFlag : plFlag}
                alt=""
                className="language-toggle-flag"
            />
            <span className="language-toggle-label">
                {language.toUpperCase()}
            </span>
        </button>
    );
};

export default LanguageToggle;
